import * as React from "react"
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { FaTwitter, FaYoutube, FaLinkedin } from "react-icons/fa"

import "../components/css/index.scss"

const Footer = () => {
  const [year, setYear] = React.useState("")
  React.useEffect(() => {
    const today = new Date()
    setYear(today.getFullYear())
  }, [])

  return (
    <footer>
      <Container>
        <Row className="align-items-center">
          <Col md={3}>
            <div className="footer-logo">
              <Link to="/">
                {/* <StaticImage src="../images/footer-logo.png" alt="footer-logo" placeholder="tracedSVG" className="ftr-img"/> */}
                <svg
                  className="ftr-img"
                  width="157"
                  height="50"
                  viewBox="0 0 157 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M46.2967 13.2969C45.1142 13.784 44.5496 15.1359 45.0404 16.3154C45.5287 17.4954 46.8842 18.0563 48.0692 17.5695C49.2517 17.0821 49.8163 15.7302 49.3255 14.5507C48.8372 13.3709 47.4817 12.8093 46.2967 13.2969Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M48.053 31.8102C46.8705 31.3206 45.5125 31.8792 45.0217 33.0584C44.5308 34.2375 45.0903 35.5896 46.2729 36.0795C47.4579 36.5689 48.8134 36.0103 49.3042 34.8313C49.7976 33.6522 49.2355 32.2997 48.053 31.8102Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M33.1302 44.8865C31.9451 45.3739 31.3831 46.7253 31.8713 47.9055C32.3596 49.085 33.7176 49.6464 34.9001 49.159C36.0852 48.6716 36.6472 47.3203 36.159 46.1403C35.6707 44.9607 34.3127 44.3994 33.1302 44.8865Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3289 44.8687C15.1464 44.3793 13.7909 44.9377 13.3 46.117C12.8067 47.2957 13.3688 48.6484 14.5513 49.138C15.7338 49.6277 17.0918 49.0688 17.5826 47.8895C18.0734 46.7113 17.5139 45.3584 16.3289 44.8687Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.43485 31.7634C0.24978 32.251 -0.312239 33.6029 0.176031 34.7827C0.664301 35.9625 2.02229 36.5233 3.20482 36.0364C4.38989 35.5491 4.95191 34.1977 4.46364 33.0174C3.97537 31.8374 2.61738 31.2765 1.43485 31.7634Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.22874 13.2536C2.04621 12.7638 0.688209 13.3229 0.197396 14.5016C-0.293416 15.6804 0.266054 17.0327 1.45113 17.5229C2.63365 18.0123 3.98912 17.4537 4.47994 16.2748C4.97329 15.0959 4.41127 13.7431 3.22874 13.2536Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5985 0.175622C13.416 0.662741 12.8515 2.01435 13.3397 3.19414C13.8306 4.37417 15.186 4.93555 16.3685 4.44817C17.5536 3.96055 18.1182 2.60919 17.6274 1.4294C17.1391 0.249373 15.7836 -0.311496 14.5985 0.175622Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.95 0.195256C33.7675 -0.294904 32.412 0.263938 31.9211 1.44296C31.4278 2.62147 31.9898 3.9741 33.1723 4.46375C34.3549 4.95366 35.7129 4.39507 36.2037 3.21605C36.6945 2.03703 36.135 0.684655 34.95 0.195256Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.4782 16.0965C37.7644 16.0968 38.7994 13.3464 37.2584 11.8096C35.7147 10.2732 32.9555 11.3052 32.9555 13.5844C32.9555 16.9443 29.2121 18.8697 26.1782 19.3487C25.6925 19.4255 23.9378 19.3525 23.4088 19.2691C20.375 18.7896 16.6315 16.865 16.6315 13.5041C16.6315 11.2248 13.8698 10.1933 12.3287 11.7294C10.7876 13.2666 11.8226 16.0169 14.1088 16.0167C17.4809 16.0175 19.4111 19.7479 19.8943 22.7709C19.9706 23.2543 19.8968 25.0066 19.8129 25.533C19.3323 28.5563 17.4021 32.287 14.03 32.2873C11.7412 32.2873 10.7062 35.0374 12.2473 36.5743C13.7909 38.1107 16.5502 37.0793 16.5502 34.7996C16.5502 31.4395 20.2935 29.5145 23.3275 29.035C23.8132 28.9585 25.5704 29.0315 26.0994 29.1146C29.1332 29.5944 32.8767 31.5193 32.8767 34.88C32.8767 37.1589 35.6359 38.1907 37.177 36.6541C38.7181 35.117 37.6856 32.3668 35.3969 32.3673C32.0248 32.3668 30.0946 28.6359 29.6139 25.6125C29.5351 25.1298 29.6088 23.3775 29.6927 22.8513C30.1734 19.8277 32.1061 16.0968 35.4782 16.0965Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.7508 6.83594C22.8231 6.83594 21.2617 8.39262 21.2617 10.3119C21.2617 12.2315 22.8231 13.7879 24.7508 13.7879C26.6759 13.7879 28.2373 12.2315 28.2373 10.3119C28.2373 8.39262 26.6759 6.83594 24.7508 6.83594Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39.1545 21.1914C37.2294 21.1914 35.668 22.7473 35.668 24.6674C35.668 26.5872 37.2294 28.1433 39.1545 28.1433C41.0822 28.1433 42.6436 26.5872 42.6436 24.6674C42.6436 22.7473 41.0822 21.1914 39.1545 21.1914Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.7508 35.5469C22.8257 35.5469 21.2617 37.1033 21.2617 39.0228C21.2617 40.9424 22.8257 42.4989 24.7508 42.4989C26.6759 42.4989 28.2373 40.9424 28.2373 39.0228C28.2373 37.1033 26.6759 35.5469 24.7508 35.5469Z"
                    fill="#555555"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3459 21.1914C8.42081 21.1914 6.85938 22.7479 6.85938 24.6674C6.85938 26.5868 8.42081 28.1436 10.3459 28.1436C12.2736 28.1436 13.835 26.5868 13.835 24.6674C13.835 22.7479 12.2736 21.1914 10.3459 21.1914Z"
                    fill="#555555"
                  />
                  <path
                    d="M62.6589 17.2816V20.8219H70.7406V23.974H62.6589V27.7169H72.9763V30.9846H58.8672V14H72.9763V17.2816H62.6589Z"
                    fill="#555555"
                  />
                  <path
                    d="M82.9749 27.7168C84.7013 27.7168 85.981 27.2883 86.812 26.4316C87.6466 25.5747 88.061 24.2619 88.061 22.4928C88.061 20.7241 87.6466 19.413 86.812 18.5602C85.981 17.7076 84.7013 17.281 82.9749 17.281H79.4909V27.7168H82.9749ZM82.9749 14C86.0235 14 88.2843 14.6949 89.7546 16.0845C91.2248 17.4747 91.9595 19.6104 91.9595 22.4928C91.9595 25.3756 91.2248 27.5113 89.7546 28.9012C88.2843 30.291 86.0235 30.9858 82.9749 30.9858H75.6992V14H82.9749Z"
                    fill="#555555"
                  />
                  <path
                    d="M109.856 22.6356V30.9846H103.119C100.022 30.9846 97.7232 30.2899 96.23 28.9008C94.7402 27.5116 93.9922 25.3746 93.9922 22.4922C93.9922 19.61 94.7402 17.473 96.23 16.0838C97.7232 14.6947 100.022 14 103.119 14H109.131V17.2816H103.119C101.345 17.2816 100.029 17.7061 99.1725 18.5582C98.3156 19.4131 97.8907 20.7236 97.8907 22.4922C97.8907 24.261 98.3156 25.5743 99.1725 26.4319C100.029 27.2868 101.345 27.7169 103.119 27.7169H106.067V22.6356H109.856Z"
                    fill="#555555"
                  />
                  <path
                    d="M126.937 17.1607H126.68L126.698 17.2816H116.62V20.8219H124.704V23.974H116.62V27.7169H126.937V30.9846H112.828V14H126.937V17.1607Z"
                    fill="#555555"
                  />
                  <path
                    d="M156.35 33.9965H151.618L146.384 30.0037H137.071C134.684 30.0037 132.738 28.0661 132.738 25.6868V18.3169C132.738 15.9376 134.684 14 137.071 14H150.296C152.684 14 154.629 15.9376 154.629 18.3169V25.6868C154.629 27.0174 154.021 28.2085 153.067 29.0006L150.341 26.9224C151.005 26.8978 151.536 26.3539 151.536 25.6868V18.3169C151.536 17.6359 150.98 17.0796 150.296 17.0796H137.071C136.388 17.0796 135.828 17.6359 135.828 18.3169V25.6868C135.828 26.3699 136.388 26.9241 137.071 26.9241H147.084L151.035 29.9403L156.35 33.9965Z"
                    fill="#555555"
                  />
                </svg>
              </Link>

              <p>
                © {year} <Link to="/">EdgeQ.</Link> All Rights Reserved.
              </p>
            </div>
          </Col>
          <Col md={6}>
            <ul className="footer-links">
              <li>
                <Link activeClassName="activeFtr" to="/company/">
                  Leadership
                </Link>
              </li>
              <li>
                <Link activeClassName="activeFtr" to="/technology/">
                  Products
                </Link>
              </li>
              <li>
                <Link activeClassName="activeFtr" to="/usecase/">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link activeClassName="activeFtr" to="/media/">
                  Newsroom
                </Link>
              </li>
              <li>
                <Link activeClassName="activeFtr" to="/career/">
                  Career
                </Link>
              </li>
              <li>
                <Link activeClassName="activeFtr" to="/contact/">
                  Contact Us
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={3}>
            <ul className="others-links">
              <li>
                <div className="socials-box">
                  <ul className="social-icon-list">
                    <li>
                      <a
                        href="https://www.linkedin.com/company/edgeq"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaLinkedin aria-label="linkdin" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/edgeq_inc?lang=en"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaTwitter aria-label="twitter" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UChEG47AbYVKYw46EGhE_dcg"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaYoutube aria-label="youtube" />
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  href="https://www.google.com/maps/place/2550+Great+America+Way,+Santa+Clara,+CA+95054,+USA/@37.4147558,-121.9758361,17z/data=!3m1!4b1!4m5!3m4!1s0x808fc836f5842907:0x32d997e7d38e2294!8m2!3d37.4147558!4d-121.9736474"
                  target="_blank"
                >
                  2550 Great America Way Suite 125 <br /> Santa Clara, CA 95054
                </a>
              </li>
              <li>
                <a href="mailto:info@edgeq.io" rel="noreferrer">
                  info@edgeq.io
                </a>
              </li>
            </ul>
            <div className="footer-logo footer-mob">
              <p>
                © {year} <Link to="/">EdgeQ.</Link> All Rights Reserved.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
